import { Injectable } from "@angular/core";
import { SolarContract } from "@edp-models/edp-solar-contract.model";
import { EdpResponseBody } from "@edp-models/response.model";
import { SolarService } from "@edp-services/solar.service";
import { ESolarActions, GetSolarContract, SetSolarContract } from "@edp-store/actions/solar.actions";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { EMPTY, of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

@Injectable()
export class SolarEffects {
    @Effect()
    loadSolarContract$ = this.actions$.pipe(
        ofType(ESolarActions.GetSolarContract),
        switchMap((action: GetSolarContract) => {
            return this.solarService.getSolarContract(action.accountNumber).pipe(
                switchMap((response: Array<Array<SolarContract>>) => {
                    if (!response || !response[0]) {
                        return of(EMPTY);
                    }
                    return of(new SetSolarContract(response[0], action.accountNumber));
                }),
                catchError(() => EMPTY)
            );
        })
    );

    constructor(private actions$: Actions, private solarService: SolarService) {}
}
